import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const IDIndex = lazy(() => import('./:id/Index'))
const Index = lazy(() => import('./Index'))

export const ExpenseDraftRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--dashboard--expense-draft']}>
    <Route path=':id/*' element={<IDIndex />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
